
import { defineComponent, PropType } from 'vue'
import { dayjs } from '@/plugins/dayjs'
import { NoticeAttributes } from '@/types/models/notice'
import { toArray } from '@/utils/array'

export default defineComponent({
  props: {
    notices: {
      type: Array as PropType<NoticeAttributes[] | undefined>,
      'default': () => ([]),
    }
  },
  setup() {
    return {
      dayjs,
      toArray
    }
  },
})
